import { useState } from "react";

export const MediaGrid = ({ items, columnsClass = "" }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const close = () => setSelectedIndex(null);
  const show = (delta) =>
    setSelectedIndex((prev) => {
      if (prev === null) return prev;
      return (prev + delta + items.length) % items.length;
    });

  const selected = selectedIndex !== null ? items[selectedIndex] : null;

  return (
    <>
      <div className={"media-grid " + columnsClass}>
        {items.map((item, i) => (
          <button
            className="media-grid-item"
            key={i}
            onClick={() => setSelectedIndex(i)}
            aria-label={item.alt}
          >
            {item.type === "video" ? (
              <div className="media-video-thumb">
                <video muted preload="metadata">
                  <source src={item.src + "#t=0.5"} type="video/mp4" />
                </video>
                <span className="media-play">▶</span>
              </div>
            ) : (
              <img
                src={item.src}
                alt={item.alt}
                loading="lazy"
                style={item.position ? { objectPosition: item.position } : undefined}
              />
            )}
          </button>
        ))}
      </div>

      {selected && (
        <div className="media-modal" role="dialog" aria-modal="true" onClick={close}>
          <div className="media-modal-inner" onClick={(e) => e.stopPropagation()}>
            <button className="media-modal-close" onClick={close} aria-label="Close">
              ×
            </button>
            <button className="media-modal-nav prev" onClick={() => show(-1)} aria-label="Previous">
              ‹
            </button>
            {selected.type === "video" ? (
              <video className="media-modal-content" controls autoPlay playsInline>
                <source src={selected.src} type="video/mp4" />
              </video>
            ) : (
              <img className="media-modal-content" src={selected.src} alt={selected.alt} />
            )}
            <button className="media-modal-nav next" onClick={() => show(1)} aria-label="Next">
              ›
            </button>
          </div>
        </div>
      )}
    </>
  );
};
